import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { t } from 'i18n'

import { Aside, Loader } from 'Components/Base'
import NotificationList from './NotificationList'
import NotificationTabs from './NotificationTabs'

import { actions } from 'Actions/notificationTray'

const i18nOpts = { scope: 'notifications' }

const NotificationTray = ({ isFetching, isLoadingMore, isOpen, notifications, activeTab, hasMore, onClose, onTabChange, onMarkAllAsRead, onLoadMore, hasUnreadNotifications }) => (
  <Aside header={t('header', i18nOpts)} isVisible={isOpen} headerColor="blue" onClose={onClose}>
    <NotificationTabs activeTab={activeTab} onTabChange={onTabChange} onMarkAllAsRead={onMarkAllAsRead} hasUnreadNotifications={hasUnreadNotifications} />
    {isFetching ? <Loader /> : <NotificationList notifications={notifications} activeTab={activeTab} hasMore={hasMore} isLoadingMore={isLoadingMore} onLoadMore={onLoadMore} />}
  </Aside>
)

NotificationTray.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  isLoadingMore: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  notifications: PropTypes.array.isRequired,
  activeTab: PropTypes.string.isRequired,
  hasMore: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onTabChange: PropTypes.func.isRequired,
  onMarkAllAsRead: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  hasUnreadNotifications: PropTypes.bool.isRequired,
}

const mapStateToProps = ({ notificationTray }) => ({
  isFetching: notificationTray.isFetching,
  isLoadingMore: notificationTray.isLoadingMore,
  isOpen: notificationTray.isOpen,
  notifications: notificationTray.notifications,
  activeTab: notificationTray.activeTab,
  hasMore: notificationTray.hasMore,
  hasUnreadNotifications: notificationTray.notifications.some((n) => n.isUnread),
})

const mapDispatchToProps = {
  onClose: actions.closeTray,
  onTabChange: actions.setActiveTab,
  onMarkAllAsRead: actions.markAllAsRead,
  onLoadMore: actions.fetchMoreNotifications,
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationTray)
